import axios from "axios";
import { domainProvider } from "src/utils/domainProvider";

export { default as api } from "./api.service";

const baseURL = (() => {
  if (process.env.REACT_APP_VERCEL_ENV === "live") {
    return `https://api.${domainProvider.TARGET_DOMAIN}`;
  }
  if (process.env.REACT_APP_VERCEL_ENV === "staging") {
    return `https://api-staging.${domainProvider.TARGET_DOMAIN}`;
  }

  return `https://api-dev.${domainProvider.TARGET_DOMAIN}`;
})();

export const maxios = axios.create({
  baseURL,
  headers: {
    "content-Type": "application/json",
    "x-freewheelin-host": domainProvider.TARGET_DOMAIN,
  },
});

maxios.defaults.headers.common["x-platform"] = "ATTENDANCE"; //TODO ATTENDANCE 교체
